import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const ENABLE_DEV_OTP =
  (process.env.REACT_APP_ENABLE_DEV_OTP || "false").toLowerCase() === "true";
export const ENABLE_MOCK_PAYMENTS =
  (process.env.REACT_APP_ENABLE_MOCK_PAYMENTS || "false").toLowerCase() ===
  "true";

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("organizer_token");
  const superAdminToken = localStorage.getItem("super_admin_token");
  const activeToken = superAdminToken || token;
  if (activeToken) config.headers.Authorization = `Bearer ${activeToken}`;
  return config;
});

export function formatApiError(err) {
  const d = err?.response?.data?.detail;
  if (!d) return err?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d))
    return d.map((e) => e?.msg || JSON.stringify(e)).join(", ");
  return String(d);
}
